"use client";

import Link from "next/link";
import { useLocale } from "next-intl";
import { GetHospitalFavoriteResponse } from "@/shared/types/type/hospital";
import { HospitalInfoType } from "@/entities/hospital/types/type";
import { LocalizedText, SearchResponse } from "@/shared/types/type/search";
import HospitalCardInfo from "../HospitalCardInfo";
import HospitalKeywords from "../HospitalKeywords";
import { useState } from "react";
import Loading from "../../organisms/Loading";
import { EmptyHospitalKeywords } from "@/widgets/hospital/ui/molecules";
import { buildHospitalShortPath } from "@/entities/hospital/lib/detail-route";
interface HospitalCardProps {
  isShowFavoriteButton?: boolean;
  info?: SearchResponse;
  favoriteInfo?: GetHospitalFavoriteResponse;
  type?: "search" | "favorite";
}
const HospitalCard = ({
  isShowFavoriteButton = true,
  info,
  favoriteInfo,
  type = "search"
}: HospitalCardProps) => {
  const locale = useLocale();
  const positiveKeywords = info?.positiveKeywords.slice(0, 3) || [];
  const negativeKeywords = info?.negativeKeywords.slice(0, 3) || [];
  const [isLoading, setIsLoading] = useState(false);
  const getHospitalInfo = () => {
    let hospitalInfo: HospitalInfoType = {
      name: "",
      fullAddress: "",
      score: 0,
      reviewCount: 0,
      categoryName: ""
    };
    if (type === "search") {
      if (!info) return hospitalInfo;
      const pickLocale = <T extends LocalizedText,>(value: T) => {
        const key = locale === "ko" || locale === "en" || locale === "jp" || locale === "cn" ? locale : "ko";
        return value[key] || value.ko;
      };
      const name = pickLocale(info.hospitalName);
      const fullAddress = pickLocale(info.address);
      hospitalInfo = {
        name,
        fullAddress,
        score: info?.score,
        reviewCount: info?.reviewCount,
        categoryName: ""
      } as HospitalInfoType;
    } else {
      favoriteInfo = favoriteInfo as GetHospitalFavoriteResponse;
      hospitalInfo = {
        hospitalOriginId: favoriteInfo.hospitalOriginId,
        name: favoriteInfo.hospitalName,
        fullAddress: favoriteInfo.address,
        categoryName: favoriteInfo.treatments?.[0]?.treatment || ""
      } as HospitalInfoType;
    }
    return hospitalInfo as HospitalInfoType;
  };
  const hospitalId = type === "search" ? info?.hospitalOriginId : favoriteInfo?.hospitalOriginId;
  const href = hospitalId ? buildHospitalShortPath(locale, hospitalId) : undefined;
  const handleCardClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
      return;
    }
    setTimeout(() => {
      setIsLoading(true);
    }, 100);
  };
  return <Link href={href ?? "#"} className="flex flex-col p-4 gap-[14px] border-b border-[#F4F4F5]" onClick={handleCardClick}>
      <HospitalCardInfo hospitalInfo={getHospitalInfo() as HospitalInfoType} isShowFavoriteButton={isShowFavoriteButton} />
      {type === "search" && <HospitalKeywords positiveKeywords={positiveKeywords} negativeKeywords={negativeKeywords} />}
      {type === "search" && positiveKeywords.length === 0 && negativeKeywords.length === 0 && <EmptyHospitalKeywords />}
      {isLoading && <Loading />}
    </Link>;
};
export default HospitalCard;